import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService, Config } from '@increff/commons';
import { FilterPipe } from 'ngx-filter-pipe';

@Component({
    selector: 'com-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() pageNo = 1;
  @Input() pageSize = 10;
  @Input() results: Array<any>;
  @Input() selectedResults: Array<any> = [];
  @Input() filterColumns: Array<string> = [];
  @Input() pageNoOption = true;
  @Input() pageSizeOption = true;
  @Input() sortOrderOption = true;

    @Output() dataEmitter: EventEmitter<{ pageNo: number; pageSize: number }> =
        new EventEmitter<{ pageNo: number; pageSize: number }>();

    pageSizeOptions: Array<number> = [];

    constructor(
        private commonService: CommonService,
        private filterPipe: FilterPipe,
        private config: Config
    ) {
        this.pageSizeOptions = this.config?.startupData?.pageSizeOptions;
    }

    ngOnInit(): void {
        this.emitPaginationParams();
        this.initTooltip();
    }

    ngOnChanges(): void {
        this.resetPagination();
        this.initTooltip();
    }

    initTooltip(): void {
        this.commonService?.initTooltip('com-pagination');
    }

    pageSizeChange(value: number = 100): void {
        this.pageSize = value;
        this.pageNo = 1;
        this.emitPaginationParams();
    }

    previousPage(): void {
        this.pageNo > 1 ? this.pageNo-- : '';
        this.initTooltip();
        this.emitPaginationParams();
    }

    nextPage(): void {
        this.pageNo++;
        this.initTooltip();
        this.emitPaginationParams();
    }

    emitPaginationParams(): void {
        this.dataEmitter?.emit({
            pageNo: Number(this.pageNo),
            pageSize: Number(this.pageSize),
        });
        this.initTooltip();
    }

    resetPagination(): void {
        this.pageNo = 1;
        this.pageSize = this.config?.startupData?.pageSizeOptions?.[0];
        this.emitPaginationParams();
    }
}
